exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".users-view .ant-table-row .ant-tag {\n  margin-left: 7px;\n}\n.users-view tr td .anticon {\n  margin-left: 7px;\n}\n", ""]);

